export default "__VITE_ASSET__B8MBYgQ8__"